import React, { useState, useEffect } from 'react';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
// import EditIcon from 'assets/edit.png'
// import { makeStyles } from '@mui/styles';
import { Button, CircularProgress, Grid, Modal, Typography } from "@mui/material";
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import AddBoxIcon from '@mui/icons-material/AddBox';
// import SuiButton from 'components/SuiButton';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import MyForm from './MyForm';
import MyFormRights from './MyFormRights';
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useAlert } from 'react-alert'
import Swal from 'sweetalert2';
import ReactSelect from 'react-select';
import axios from 'axios';
const useInlineStyles = () => ({
  treeItem: {
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  label: {
    fontSize: '1rem',
    fontWeight: 'normal',
    flexGrow: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  addButton: {
    marginLeft: 'auto',
  },
  editButton: {
    marginLeft: '4px',
  },
});
const Rights = ({ notShow ,RolesId}) => {
  const classes = useInlineStyles();
  // const alert = useAlert()
      const token = localStorage.getItem("Token");

  const [treeData, setTreeData] = useState([]);
  const [ids, setId] = useState([]);
  const [expandedNodes, setExpandedNodes] = useState([]);
  const [selectedNodes, setSelectedNodes] = useState([]);



  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [parentId, setParentId] = useState('');
  const [parentId1, setParentId1] = useState('');

  const [isActive, setisActive] = useState('');
  const [name, setName] = useState('');
  const [nodesvalues, setvalues] = useState('');
  const defaultpracticeId = localStorage.getItem('default_paractice')

  const [updatedBy, setupdatedBy] = useState('');
  const [createdBy, setcreatedBy] = useState('');
  const [submitting, setSubmitting] = useState(false)
  const [refresh, setRefresh] = useState(false);

  const [nodeId, setNodeId] = useState('');
  const [applyRefresh, setapplyRefresh] = useState(false);


  const applyRefreshh = () => {
    setapplyRefresh(!applyRefresh)
  }



  const handleClose = () => setOpen(false);

  const handleCloseEdit = () => setOpenEdit(false);
  const [treeData1, setTreeData1] = useState(null);
 
  const [selectedOption, setSelectedOption] = useState('1');
  const [selectedNodeId, setSelectedNodeId] = useState(null); // Initializing with null or appropriate default value
  const [selectedRoleId, setSelectedRoleId] = useState(null); // Initializing with null or appropriate default value
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Module/Roles?defaultpracticeId=${defaultpracticeId}`,
         { headers: {
            Authorization: `Bearer ${token}`,
          },}
        )
        .then(response => {
          const bprov = response.map(field => ({
            label: field.name,
            value: field.id,
          }));
          setTreeData1(bprov);
        })
        .catch(error => {
          console.error("Error fetching referring physicians:", error);
        });
  }, [refresh,applyRefresh]);
  const toggleNode = (id) => {
    setExpandedNodes((prevExpandedNodes) =>
      prevExpandedNodes.includes(id)
        ? prevExpandedNodes.filter((nodeId) => nodeId !== id)
        : [...prevExpandedNodes, id]
    );
  };
  const handleNodeSelect = async (event, nodeId, rightsId, roleId, moduleId, isChecked) => {
    // Disable the checkbox during API call
    setIsSubmitting(true);

    try {
      // Update the selectedNodes state based on the checkbox state
      if (event.target.checked) {
        setSelectedNodes((prevSelectedNodes) => [...prevSelectedNodes, nodeId]);
      } else {
        setSelectedNodes((prevSelectedNodes) =>
          prevSelectedNodes.filter((selectedNodeId) => selectedNodeId !== nodeId)
        );
      }

      // Call onSubmitUpdate to submit changes
      await onSubmitUpdate(moduleId, isChecked, rightsId, roleId);
    } finally {
      // Re-enable the checkbox after API call completes (whether it succeeds or fails)
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!RolesId && selectedOption) {
      fetchTreeData(selectedOption);
    }
  }, [selectedOption, applyRefresh, refresh]);


    useEffect(() => {
    if (RolesId) {
      fetchTreeDatawithProps(selectedOption);
    }
  }, [RolesId]);
  
  
  // const fetchTreeData = async (roleId) => {
  //   if (!roleId || !selectedOption) {
  //     return
  //   }
  //   setSubmitting(true);
  //   try {
  //     const response = await fetch(`${process.env.REACT_APP_API_URL}/Rights/getRights?roleId=${roleId ? roleId : selectedOption}`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     if (!response.ok) {
  //       throw new Error('Failed to fetch tree data');
  //     }
  //     const data = await response.json();
  //     setTreeData(data);
  //     setSubmitting(false);
  //   } catch (error) {
  //     setSubmitting(false);
  //     console.error('Error fetching tree data:', error);
  //   }
  // };
  const fetchTreeData = async (roleId) => {
    if (!roleId || !selectedOption) {
      return;
    }
    setSubmitting(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Rights/getRights?roleId=${roleId ? roleId : selectedOption}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      setTreeData(response);
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
      console.error('Error fetching tree data:', error);
    }
  };

  const fetchTreeDatawithProps = async (roleId) => {
    if (!roleId || !selectedOption) {
      return;
    }
    setSubmitting(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Rights/getRights?roleId=${RolesId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      setTreeData(response);
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
      console.error('Error fetching tree data:', error);
    }
  };
  
  const findNodeById = (nodes, id) => {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const foundNode = findNodeById(node.children, id);
        if (foundNode) {
          return foundNode;
        }
      }
    }
    return null;
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px'
  };
  const getAllNodeIds = (nodes) => {
    let ids = [];
    nodes.forEach(node => {
      ids.push(node.id);
      if (node.children && node.children.length > 0) {
        ids = ids.concat(getAllNodeIds(node.children));
      }
    });
    return ids;
  };

  useEffect(() => {

    const allNodeIds = getAllNodeIds(treeData);
    setExpandedNodes(allNodeIds);
  }, [treeData]);

  const handleDrop = async (draggedItemId, newParentId) => {

    try {
      const draggedItem = findNodeById(treeData, draggedItemId);
      if (!draggedItem) {
        throw new Error('Dragged item not found in tree data');
      }

      // Create the updated data for the API call
      const updatedData = {
        id: draggedItemId,
        parentId: newParentId,
        isActive: false,
        name: draggedItem.name, // Include the name property from the dragged item
      };

      // Perform the API call to update the parent ID
      const response = await fetch(`${process.env.REACT_APP_API_URL}/Module/AddModules`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },

        body: JSON.stringify(updatedData),
      });

      if (!response.ok) {
        throw new Error('Failed to move module');
      } else {
        setRefresh(!refresh)
      }

      // Update the tree data after successful API call
      const updatedNode = await response.json();
      setTreeData(prevTreeData => {
        const updateTree = (nodes) => {
          return nodes.map(node => {
            if (node.id === newParentId) {
              // Append the new node to the children
              return {
                ...node,
                children: node.children ? [...node.children, updatedNode] : [updatedNode],
              };
            }
            if (node.children && node.children.length > 0) {
              // Recursively update the children nodes
              return {
                ...node,
                children: updateTree(node.children),
              };
            }
            return node;
          });
        };
        return updateTree(prevTreeData);
      });
    } catch (error) {
      console.error('Error moving module:', error);
    }
  };

  const onSubmitUpdate = async (moduleId, isChecked, rightsId, roleId) => {
    try {
      setIsSubmitting(true);
      const postData = [{
        id: rightsId ? rightsId : 0, 
        roleId: selectedOption,
        moduleId: moduleId,
        defaultpracticeId: defaultpracticeId,
        isChecked: isChecked, 
        isUpdated: true,
        description: '',
        moduleIds: [],
        createdBy: '', 
        updatedBy: '',
      }];

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/Rights/AddRights`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        title: 'Rights Updated',
        text: 'Rights updated successfully',
        icon: 'success',
        timer: 1000,
      });
      setRefresh(!refresh); 
    } catch (error) {

      Swal.fire({
        title: 'Error',
        text: 'There was an error updating the rights.',
        icon: 'error',
      });
    } finally {
      setIsSubmitting(false); // Reset the submitting state

      // Optional: any final operations if needed
    }
  };

  // const renderTree = (node) => (
  //   <div key={node.id}  style={{
  //     margin: '8px 0',
  //     padding: '10px 16px',
  //     backgroundColor: '#f5f5f5',
  //     borderRadius: '10px',
  //     boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
  //     transition: 'background-color 0.3s',
  //   }}>
  //     <div
  //       draggable
  //       onDragStart={(e) => {
  //         setName(node.moduleName);
  //         e.dataTransfer.setData('text/plain', node.id);
  //       }}
  //       onDragOver={(e) => {
  //         e.preventDefault();
  //       }}
  //       onDrop={(e) => {
  //         setId(node.id);
  //         setName(node.moduleName);
  //         e.preventDefault();
  //         const draggedItemId = e.dataTransfer.getData('text/plain');
  //         handleDrop(parseInt(draggedItemId), node.id);
  //       }}
  //       onClick={() => toggleNode(node.id)}
  //       style={{
  //         cursor: 'pointer',
  //         display: 'flex',
  //         alignItems: 'center',
  //         justifyContent: 'space-between',
  //         transition: 'background 0.3s',
  //       }}
  //     >
  //       <h3 style={{ display: 'flex', alignItems: 'center' }}>
  //         {node.children && node.children.length > 0 ? (
  //           expandedNodes.includes(node.id) ? (
  //             <FolderOpenIcon style={{ verticalAlign: 'middle', color: '#3C7F6B' }} />
  //           ) : (
  //             <FolderIcon style={{ verticalAlign: 'middle', color: '#3C7F6B' }} />
  //           )
  //         ) : null}
  //         <FormControlLabel
  //           control={
  //             <Checkbox style={{ marginLeft: '1rem' }}
  //               disabled={isSubmitting}
  //               onClick={(e) => {
  //                 e.stopPropagation()
  //               }}
  //               checked={node.isChecked}
  //               onChange={(event) => handleNodeSelect(event, node.id, node.rightsId, node.roleId, node.id, event.target.checked ? 1 : 0)}
  //               value={node.id}
  //             />

  //           }
  //         //  label={node.moduleName}
  //         />
  //         <span style={{ marginLeft: '-0.5rem', fontSize: 'medium' }}>{node.moduleName}</span>


  //         <div style={{ marginLeft: '10px' }}>



  //           <>


  //           </>
  //         </div>
  //       </h3>
  //     </div>
  //     {expandedNodes.includes(node.id) && node.children && node.children.length > 0 && (
  //       <div style={{ marginLeft: '16px' }}>
  //         {node.children.map((child) => (
  //           <div key={child.id} onClick={() => { setName(child.name); console.log(`Clicked on ${child.name}`); }}>
  //             {renderTree(child)}
  //           </div>
  //         ))}
  //       </div>
  //     )}
  //   </div>
  // );

  const renderTree = (node) => (
    <div
      key={node.id}
      style={{
        margin: '10px 0',
        paddingLeft: '16px',
        borderLeft: '3px solid #e2e8f0',
        transition: 'all 0.3s ease-in-out',
      }}
    >
      <div
        draggable
        onDragStart={(e) => {
          setName(node.moduleName);
          e.dataTransfer.setData('text/plain', node.id);
        }}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          setId(node.id);
          setName(node.moduleName);
          e.preventDefault();
          const draggedItemId = e.dataTransfer.getData('text/plain');
          handleDrop(parseInt(draggedItemId), node.id);
        }}
        onClick={() => toggleNode(node.id)}
        style={{
          cursor: 'pointer',
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          padding: '10px 14px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          transition: 'transform 0.2s',
          position: 'relative',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.01)';
          e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,0,0,0.08)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.05)';
        }}
      >
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {node.children && node.children.length > 0 ? (
            expandedNodes.includes(node.id) ? (
              <FolderOpenIcon style={{ color: '#4CAF50', fontSize: '22px' }} />
            ) : (
              <FolderIcon style={{ color: '#4CAF50', fontSize: '22px' }} />
            )
          ) : (
            <span style={{ color: '#bbb' }}>•</span>
          )}
  
          <FormControlLabel
            control={
              <Checkbox
                style={{ color: '#2E7D32' }}
                disabled={isSubmitting}
                onClick={(e) => e.stopPropagation()}
                checked={node.isChecked}
                onChange={(event) =>
                  handleNodeSelect(
                    event,
                    node.id,
                    node.rightsId,
                    node.roleId,
                    node.id,
                    event.target.checked ? 1 : 0
                  )
                }
                value={node.id}
              />
            }
            label={
              <span style={{ fontSize: '16px', fontWeight: '500', color: '#2E7D32' }}>
                {node.moduleName}
              </span>
            }
          />
        </div>
      </div>
  
      {expandedNodes.includes(node.id) && node.children && node.children.length > 0 && (
        <div style={{ marginLeft: '20px', marginTop: '10px' }}>
          {node.children.map((child) => (
            <div
              key={child.id}
              onClick={() => {
                setName(child.name);
                console.log(`Clicked on ${child.name}`);
              }}
            >
              {renderTree(child)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
  
  
  return (
  <>
  {!notShow && (
   <Box
  style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    border: '2px solid #4CAF50',
    borderRadius: '10px',
    padding: '20px',
    backgroundColor: '#f1f8e9',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  }}
>
   
  <Box
    style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '12px',
    }}
  >
    <Typography
      style={{
        fontSize: '22px',
        fontWeight: 'bold',
        color: '#2e7d32',
      }}
    >
      Roles
    </Typography>

    <Button
    onClick={()=>{onSubmitUpdate()}}
      style={{
        height: '36px',
        backgroundColor: '#3C7F6B',
        color: '#fff',
        borderRadius: '8px',
        padding: '6px 14px',
        display: 'flex',
        alignItems: 'center',
        fontWeight: 500,
        fontSize: '14px',
        cursor: 'pointer',
      }}
    >
      <SaveOutlinedIcon
        fontSize="small"
        style={{
          marginRight: '6px',
          color: '#fff',
        }}
      />
      SAVE
    </Button>
  </Box>

  <ReactSelect
    options={treeData1}
    value={treeData1?.find(option => option.value == selectedOption)}
    onChange={(option) => setSelectedOption(option.value)}
    styles={{
      control: (base) => ({
        ...base,
        height: '40px', 
        width: '240px', 
        zIndex: 1, 
      }),
      menuPortal: (base) => ({
        ...base,
        zIndex: 9999, 
      }),
      menu: (base) => ({
        ...base,
        maxHeight: '300px',
        overflowY: 'auto', 
      }),
      menuList: (base) => ({
        ...base,
        maxHeight: '200px',
        marginBottom: '10px',
        // Scrollbar styling
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#aec3b0', 
          borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#8B4513', 
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#f5f5f5',
        },
      }),
    }}
    placeholder="Select Role"
  />
</Box>

)}
    <Modal
      open={openEdit}
      onClose={handleCloseEdit}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div><MyFormRights createdBy={createdBy} update={'update'} applyRefresh={applyRefreshh} defaultpracticeId={defaultpracticeId} name={name} nodesvalues={nodesvalues} updatedBy={updatedBy} handleClose={handleCloseEdit} nodeId={nodeId} parentId={parentId} isActive={isActive} /></div>        </Box>
    </Modal>

    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div><MyFormRights handleClose={handleClose} parentId={parentId1} applyRefresh={applyRefreshh} /></div>
      </Box>
    </Modal>
    {submitting ? (
      <CircularProgress
        style={{
          width: '50px',
          height: '50px',
          position: 'absolute',
          left: '50%',
          top: '70%',
          marginLeft: '-25px',
          marginTop: '25px',
          zIndex: 1000,
          color: '#3C7F6B',
        }}
      />
    ) : null}
    
    <div>
       {!notShow && (
      <Typography style={{ fontSize: '25px', fontWeight: 'bold', marginTop: 30 }}>Rights</Typography>
  )}
      {Array.isArray(treeData) && treeData.map((node) => renderTree(node))}
    </div>
   
  </>
  );
};

export default Rights;
